import React, { useState } from 'react';
import '../styles/sidebar.css';

function Sidebar({ user, onLogout }) {
  const [showUserMenu, setShowUserMenu] = useState(false);

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h2>Employee Docs</h2>
        <p className="role-badge">Administrator</p>
      </div>

      <nav className="sidebar-nav">
        <ul>
          <li><a href="/dashboard">Dashboard</a></li>
          <li><a href="/employees">All Employees</a></li>
          <li><a href="/documents">All Documents</a></li>
          <li><a href="/users">User Management</a></li>
          <li><a href="/logs">System Logs</a></li>
        </ul>
      </nav>

      <div className="sidebar-footer">
        <div className="user-info" onClick={() => setShowUserMenu(!showUserMenu)}>
          <div className="user-avatar">{(user.name || 'U').charAt(0)}</div>
          <div className="user-details">
            <p className="user-name">{user.name}</p>
            <p className="user-email">{user.email}</p>
          </div>
        </div>

        {showUserMenu && (
          <div className="user-menu">
            <a href="/profile">Profile Settings</a>
            <a href="/change-password">Change Password</a>
            <button onClick={onLogout}>Logout</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Sidebar;
